module.exports = __webpack_public_path__ + "static/img/tangzhe.c3a41c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/tangzhe.jpg
// module id = GnBP
// module chunks = 1